import React from "react"

const AvisHoraris = () => {
  return (
    <div className='border-b border-l border-r border-blu flex justify-center px-4 py-4 sm:py-6'>
      <div className='inline-flex items-center gap-2 bg-gray rounded-full px-4 py-2 sm:px-5 max-w-3xl'>
        <svg
          className='w-5 h-5 flex-shrink-0 text-blue'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M12 9v3.75m0 3.75h.008M12 3.75L2.25 20.25h19.5L12 3.75z'
          />
        </svg>
        <p className='text-blue font-mori text-sm sm:text-base'>
          <span className='font-bold'>Avís important sobre els horaris:</span>{" "}
          totes les obres de temporada canvien d'horari i es
          passaran a fer a les 11:30&nbsp;h o a les 17:30&nbsp;h (a excepció dels Pastorets).
        </p>
      </div>
    </div>
  )
}

export default AvisHoraris
